import { render, staticRenderFns } from "./LinkPOS.vue?vue&type=template&id=2b78f402"
import script from "./LinkPOS.vue?vue&type=script&lang=js"
export * from "./LinkPOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports